import React, { useState, useContext } from "react";

import { useHistory } from "react-router-dom";
import { ALL_ITEMS_VIEW_QUERY_BY_PAGE_QUERY } from "../../../graphql/Items/Items.graphql";

import { AddItemForm } from "../../../components/Items";

import { ModalContext } from "../../../components/ModalProvider";

import DataTable from "../../../components/DataTable";
import { ITEM_COLUMNS } from "./columns";

import PageHeader from "../../../components/PageHeader";
import ItemFilters from "./ItemFilters";
import { getFilterState, saveFilterState } from "../../../utils";
import { useAuthorization } from "../../../components/Authorization";

const ItemsPage = () => {
  const history = useHistory();
  const Auth = useAuthorization(["ADMIN", "FLEET", "MGMNT", "FIN"]);
  const INITIAL_FILTER_STATE = getFilterState("ITEM_FILTERS", {
    Active: true
  });
  const { setModalOpen } = useContext(ModalContext);

  const [filters, setFilters] = useState(INITIAL_FILTER_STATE);
  const handleSetFilters = inputs => {
    saveFilterState("ITEM_FILTERS", inputs);
    setFilters({ ...inputs });
  };
  const resetFilters = () => handleSetFilters({ Active: true });

  return (
    <React.Fragment>
      <PageHeader
        FilterComponent={ItemFilters}
        columns={ITEM_COLUMNS(Auth)}
        filters={filters}
        name="VW_ItemsByPage"
        query={ALL_ITEMS_VIEW_QUERY_BY_PAGE_QUERY}
        resetFilters={resetFilters}
        setFilters={handleSetFilters}
        title="Items"
        onAddClick={() =>
          setModalOpen(
            true,
            <AddItemForm onComplete={() => setModalOpen(false, "")} />
          )
        }
      />
      <DataTable
        isPaginated
        columns={ITEM_COLUMNS(Auth)}
        dataQuery={ALL_ITEMS_VIEW_QUERY_BY_PAGE_QUERY}
        initialSortBy={[
          { id: "ItemNo", desc: false },
          { id: "Description", desc: false }
        ]}
        name="VW_ItemsByPage"
        where={filters}
        onRowClick={data =>
          history.push(`/inventory/items/${data.RecId}/details`)
        }
      />
    </React.Fragment>
  );
};

ItemsPage.propTypes = {};
export default ItemsPage;
